<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-6 text-sm-right">
                        <button type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i
                                class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                    </div>
                </div>
            </div>

            <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                    class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Rol-Aplicación</th>
                            <th>Rol-Aplicación</th>
                            <th>Permisos</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of resultadoRolesAppPermisos; let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{ row.nombreRol}}</td>
                            <td>{{ row.nombreAplicacion}}</td>
                            <td>
                        <tr *ngFor="let row2 of row.permisos">{{ row2.nombrePermiso}}</tr>
                        </td>
                        <td>{{((row.estado == '1')? 'Activo': 'Inactivo')}}</td>
                        <td class="text-center ">
                            <div class="row">
                                <button type="button" tooltip="Editar"
                                    class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                    title="Editar este registro" (click)="edit(row)">
                                    <i class="fas fa-pencil-alt fa-lg"></i>
                                </button>
                                <button type="button" class="btn btn-sm btn-link waves-effect col px-0"
                                    title="Eliminar este registro" (click)="delete(row.idSprRol)">
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                </button>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-app-permiso" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>


<jw-modal id="{{nameModal}}">
    <!-- MODAL PARA CREAR Y EDITAR -->

    <div class="modal-dialog" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="closeModal();" aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <form class="needs-validation" novalidate id="formAppPermisos" [formGroup]="formAppPermisos">

                    <div class="row">
                        <input type="hidden" id="idSprAppPermiso" formControlName="idSprAppPermiso"
                            value="{{idSprAppPermiso}}">
                        <div class="form-floating mb-3">
                            <select class="form-select col-9" formControlName="idSprRol" required="true" [ngClass]="{'is-invalid': this.formAppPermisos.get('idSprRol')?.errors && this.submitted,
                                'is-valid': !this.formAppPermisos.get('idSprRol')?.errors,}">

                                <option *ngFor="let row of dataRoles" value={{row.idSprRol}}>
                                    {{row.nombre}}
                                </option>
                            </select>
                            <small class="invalid-feedback"
                                *ngIf="this.formAppPermisos.get('nombre')?.errors?.['required'] && this.submitted">
                                Campo requerido</small>
                            <label for="idSprRol" class="col-form-label text-md-right"><b>Rol</b>
                            </label>
                        </div>

                        <div class="form-floating mb-3">
                            <select class="form-select col-9" formControlName="idSprAplicacion" required="true"
                                [ngClass]="{'is-invalid': this.formAppPermisos.get('idSprAplicacion')?.errors && this.submitted,
                                'is-valid': !this.formAppPermisos.get('idSprAplicacion')?.errors,}">

                                <option *ngFor="let row of dataAplicaciones" value={{row.idSprAplicacion}}>
                                    {{row.nombre}}
                                </option>
                            </select>
                            <small class="invalid-feedback"
                                *ngIf="this.formAppPermisos.get('nombre')?.errors?.['required'] && this.submitted">
                                Campo requerido</small>
                            <label for="idSprAplicacion" class="col-form-label text-md-right"><b>Aplicación</b>
                            </label>
                        </div>
                        <!-- <div class="form-floating mb-3">
                                <select class="form-select col-9" formControlName="idSprPermiso" required="true"
                                [ngClass]="{'is-invalid': this.formAppPermisos.get('idSprPermiso')?.errors && this.submitted,
                                'is-valid': !this.formAppPermisos.get('idSprPermiso')?.errors,}">
                  
                                  <option *ngFor="let row of dataPermisos" value={{row.idSprPermiso}}>
                                    {{row.nombre}}
                                  </option>
                                </select>
                              <small class="invalid-feedback"
                                *ngIf="this.formAppPermisos.get('nombre')?.errors?.['required'] && this.submitted">
                                    Campo requerido</small>
                                    <label for="idSprPermiso" class="col-form-label text-md-right"><b>Permiso</b>
                                    </label>
                            </div>-->

                        <div class="form-floating mb-3">
                            <div *ngFor="let row of getPermisos; let indice = index" class="form-check">
                                <input type="checkbox" class="form-check-input"
                                    (change)="onChangePermisos($event,row.idSprPermiso)" id={{row.idSprPermiso}}
                                    name="option1{{indice}}" value={{row.idSprPermiso}} [checked]="row.checked">
                                <label for={{row.idSprPermiso}} class="form-check-label">
                                    <a>{{row.nombre}}</a>
                                </label>

                            </div>
                        </div>

                        <div class="form-floating mb-3">
                            <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{
                                    'is-invalid': this.formAppPermisos.get('estado')?.errors && this.submitted,
                                    'is-valid': !this.formAppPermisos.get('estado')?.errors, }">
                                <option value="1" selected>Activo</option>
                                <option value="2">Inactivo</option>
                            </select>
                            <label for="estado">Estado</label>
                            <small class="invalid-feedback"
                                *ngIf="this.formAppPermisos.get('estado')?.errors?.['required'] && this.submitted">
                                Campo
                                requerido</small>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModal();">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="onSubmit(rolSeleccionado)">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>